interface DeviceConfig {
	Beep: boolean;
	OutputPower: boolean;
	LoadAlarm: {
		Enabled: boolean;
		Lower: number;
		Upper: number;
	};
}

export interface Smartplug2 {
	ConnectionLost: boolean;
	Consumption: number;
	ConsumptionNotification: {
		Enabled: boolean;
		Triggered: boolean;
		Threshold: number;
	};
	DeviceConfig: DeviceConfig;
	Firmware: string;
	Fota: {
		Approved: boolean;
		Filename: string;
	};
	Imei: string;
	Imsi: string;
	LastUploadAt: string;
	Load: number;
	Metadata: DeviceMetadata;
	PowerFailureNotification: {
		Enabled: boolean;
		Triggered: boolean;
	};
	SignalStrength: number;
	Subscription: Subscription;
	TargetConfig: DeviceConfig;
	Timer: {
		Enabled: boolean;
		Rules: TimerRule[];
	};
}

export interface TimerRule {
	Action: string;
	Schedule: string;
	Timezone: string;
}

export const sp2Placeholder: Smartplug2 = {
	ConnectionLost: false,
	Consumption: 0,
	ConsumptionNotification: {
		Enabled: false,
		Triggered: false,
		Threshold: 0,
	},
	DeviceConfig: {
		Beep: false,
		LoadAlarm: {
			Enabled: false,
			Lower: 0,
			Upper: 0,
		},
		OutputPower: false,
	},
	Firmware: "",
	Fota: {
		Approved: false,
		Filename: "",
	},
	TargetConfig: {
		Beep: false,
		LoadAlarm: {
			Enabled: false,
			Lower: 0,
			Upper: 0,
		},
		OutputPower: false,
	},
	Imei: "",
	Imsi: "",
	LastUploadAt: "",
	Load: 0,
	Metadata: {
		OwnerEmail: "",
		Name: "",
		Tags: [""],
		Access: [""],
		Notify: [""],
	},
	PowerFailureNotification: {
		Enabled: false,
		Triggered: false,
	},
	SignalStrength: 0,
	Subscription: {
		ExpiresAt: "",
		PriceIds: {
			Current: "",
			Next: "",
		},
		Trialing: false,
	},
	Timer: {
		Enabled: false,
		Rules: [
			{
				Action: "turn_on",
				Schedule: "0 0 1,2,3,4,5,6,7",
				Timezone: "Europe/Stockholm",
			},
		],
	},
};
